import {
    DossierRoutingProvider,
    dossiersBasePath,
    OfferProvider,
    SelectedOrderProvider,
    dossierValidationPath,
} from '@europrocurement/l2d-modules';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { ordersBasePath } from '../constants';

export const OrderRoot: React.FunctionComponent = function () {
    return (
        <OfferProvider>
            <DossierRoutingProvider
                orderBasePath={ordersBasePath}
                dossierBasePath={dossiersBasePath}
                dossierValidationPath={dossierValidationPath}
            >
                <SelectedOrderProvider>
                    <Outlet />
                </SelectedOrderProvider>
            </DossierRoutingProvider>
        </OfferProvider>
    );
};
